import React from "react";
import ReactDOM from "react-dom/client";
import "noto-color-emoji-flags";
import "./index.css";
import "./telegramBridge";
import { initBugsink, Sentry } from "./bugsink";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Login from "./pages/Login";
import Account from "./pages/Account";
import { createBrowserRouter, RouterProvider } from "react-router";
import Settings from "./pages/Settings";
import "./i18n";
import Subscription from "./pages/Subscription";
import Guide from "./pages/Guide";
import Support from "./pages/Support";
import TermsAndPolicies from "./pages/TermsAndPolicies";
import ChangeOutlet from "./pages/ChangeOutlet";
import GuidesAll from "./pages/GuidesAll";
import ErrorPage from "./ErorrPage";
import SubscriptionOnline from "./pages/SubscriptionOnline";
import PaymentStatus from "./pages/PaymentStatus";
import { restoreToken } from "./utils/tokenStorage";

initBugsink();

window.Telegram?.WebApp?.ready?.();

const createRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

const routes = createRouter([
  {
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <Login />,
      },
      {
        index: true,
        path: "/login",
        element: <Login />,
      },
      {
        path: "/account",
        element: <Account />,
      },
      {
        path: "/account/settings",
        element: <Settings />,
      },
      {
        path: "/account/subscription",
        element: <Subscription />,
      },
      {
        path: "/account/guide/:login?",
        element: <Guide />,
      },
      {
        path: "/account/guide/:login?/all/:os?/:protocol?",
        element: <GuidesAll />,
      },
      {
        path: "/account/support",
        element: <Support />,
      },
      {
        path: "/termsandpolicies",
        element: <TermsAndPolicies />,
      },
      {
        path: "/account/outlet",
        element: <ChangeOutlet />,
      },
      {
        path: "/account/subscription-exit",
        element: <ChangeOutlet />,
      },
      {
        path: "/account/online",
        element: <SubscriptionOnline />,
      },
      {
        path: "/payment/success",
        element: <PaymentStatus />,
      },
      {
        path: "/payment/fail",
        element: <PaymentStatus />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

// Ждём восстановления токена из Telegram CloudStorage, чтобы первое решение
// «логин или аккаунт» принималось уже с восстановленным токеном.
restoreToken().finally(() => {
  root.render(
    <React.StrictMode>
      <RouterProvider router={routes} />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
